
const IMAGE_CLICK_ACTIONS = {
    none: 'disabled',
    expand: 'zoomMode',
    link: 'goToLink'
};

const EFFECTS = {
    //TODO WEED-8265
    // CURRENT_EDITOR_EFFECT: {
    //     name: 'currentEditorEffect'
    // },
    HIDE: {
        suffix: 'Out',
        noSuffixPresets: ['conceal'],
        deprecatedValues: ['ArcOut',
            'BounceOut',
            'CollapseOut',
            'Conceal',
            'FadeOut',
            'FlipOut',
            'FloatOut',
            'FlyOut',
            'FoldOut',
            'GlideOut',
            'PopOut',
            'SlideOut',
            'SpinOut',
            'TurnOut']
    },
    SHOW: {
        suffix: 'In',
        noSuffixPresets: ['reveal'],
        deprecatedValues: ['ArcIn',
            'BounceIn',
            'DropIn',
            'ExpandIn',
            'FadeIn',
            'FlipIn',
            'FloatIn',
            'FlyIn',
            'FoldIn',
            'GlideIn',
            'Reveal',
            'SlideIn',
            'SpinIn',
            'TurnIn']
    }
};

export default {
    IMAGE_CLICK_ACTIONS,
    EFFECTS
};



// WEBPACK FOOTER //
// ./js/modules/privates/constants.es6